<template>
  <div class="flex max-sm:flex-wrap justify-center gap-5">
    <div v-if="nidoLocal.parts.left">
      <p class="text-pragmatica-extended mb-2 text-center text-sm font-bold">
        {{ $t('nido.position.left') }}
      </p>
      <hr class="-mx-3 mb-3" />
      <InkStraight
        :part="nidoLocal.parts.left"
        :can-be-corner="!nidoLocal.neighborLeft"
      />
    </div>
    <div v-if="nidoLocal.parts.center">
      <p class="text-pragmatica-extended mb-2 text-center text-sm font-bold">
        {{ $t('nido.position.center') }}
      </p>
      <hr class="-mx-3 mb-3" />
      <InkStraight
        :part="nidoLocal.parts.center"
        :can-be-corner="
          nidoLocal instanceof NidoSingle &&
          (!nidoLocal.neighborRight || !nidoLocal.neighborLeft)
        "
      />
    </div>
    <div v-if="nidoLocal.parts.right">
      <p class="text-pragmatica-extended mb-2 text-center text-sm font-bold">
        {{ $t('nido.position.right') }}
      </p>
      <hr class="-mx-3 mb-3" />
      <InkStraight
        :part="nidoLocal.parts.right"
        :can-be-corner="!nidoLocal.neighborRight"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { NidoSingle } from '~/service/experience/world/nido/Nido'
import { NidoDouble } from '~/service/experience/world/nido/Nido'
import { NidoTriple } from '~/service/experience/world/nido/Nido'

const props = defineProps<{
  nido: NidoSingle | NidoDouble | NidoTriple
}>()

const nidoLocal = ref(props.nido)

// TODO: On 'update' emit call addCollider()
</script>

<style lang="scss" scoped></style>
